import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Nav } from './Nav';
import { Footer } from './Footer';
type Props = {
  title: string;
  children: React.ReactNode;
};

/** Shared frame for every subpage: the floating menu dock, page content and the footer. */
export function SubpageLayout({
  title,
  children
}: Props) {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  useEffect(() => {
    document.title = `${title} — LAEBEL`;
  }, [title]);
  return <div id="top" className="min-h-screen w-full bg-bg text-fg" data-id="element-383" data-mp="p3z9jklnv8to">
      <Nav data-id="element-384" data-mp="aetem8tuw4rl" />
      <main data-id="element-385" data-mp="af2xlcghhbns">{children}</main>
      <Footer data-id="element-386" data-mp="afuowb31sn89" />
    </div>;
}